import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import RnRLogo from '../components/public/RnRLogo';

export default function ImpressumPage() {
  return (
    <div className="min-h-screen bg-bg-primary text-text-primary">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <div className="mb-10 flex items-center justify-between">
          <Link to="/" className="inline-flex items-center gap-2 font-body text-text-muted text-sm hover:text-accent-red transition-colors">
            <ArrowLeft size={16} />
            Zurück zur Startseite
          </Link>
          <RnRLogo className="h-14" />
        </div>

        <h1 className="font-heading text-5xl md:text-6xl text-text-primary mb-12">IMPRESSUM</h1>

        <div className="space-y-10 font-body text-text-muted leading-relaxed">

          <section>
            <h2 className="font-heading text-xl text-text-primary mb-4">ANGABEN GEMÄSS § 5 TMG</h2>
            <p>prOju – Projekt Offene Jugendarbeit</p>
            <p>Katholische Kirchengemeinde St. Peter und Paul</p>
            <p>Kirchstraße 18</p>
            <p>53557 Bad Hönningen</p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-text-primary mb-4">VERANTWORTLICH FÜR DEN INHALT</h2>
            <p>Nicole Emmler</p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-text-primary mb-4">KONTAKT</h2>
            <p>Tel.: 02635 / 5355</p>
            <p>Mobil: 0157 / 34 22 81 84</p>
            <p className="mt-2">
              E-Mail:{' '}
              <a href="mailto:info@proju.org" className="text-accent-red hover:underline">
                info@proju.org
              </a>
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-text-primary mb-4">HAFTUNG FÜR INHALTE</h2>
            <p>
              Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit,
              Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
              Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten
              nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
              Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
              Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
              Tätigkeit hinweisen.
            </p>
            <p className="mt-3">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
              allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch
              erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei
              Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
              entfernen.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-text-primary mb-4">HAFTUNG FÜR LINKS</h2>
            <p>
              Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen
              Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr
              übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder
              Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
              Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum
              Zeitpunkt der Verlinkung nicht erkennbar.
            </p>
            <p className="mt-3">
              Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
              Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
              Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-text-primary mb-4">URHEBERRECHT</h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
              dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art
              der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen
              Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind
              nur für den privaten, nicht kommerziellen Gebrauch gestattet.
            </p>
            <p className="mt-3">
              Copyright: prOju, Samuel Yankey, Nicole Emmler
            </p>
          </section>

        </div>

        <div className="mt-16 pt-8 border-t border-divider flex gap-6 text-xs font-body text-text-muted">
          <Link to="/impressum" className="hover:text-accent-red transition-colors">Impressum</Link>
          <Link to="/datenschutz" className="hover:text-accent-red transition-colors">Datenschutz</Link>
        </div>
      </div>
    </div>
  );
}
